import { TrackingConditionsTypes, TreatmentTrackOptions } from './giConsts'

export const TxTrackingListTypes = {
  TrackStatus: 'trackStatus',
  TrackingReasons: 'trackingReasons',
  NotOnTrackStreak: 'notOnTrackStreak'
}

/**
 * The track status chips. `key` doubles as the i18n label key
 * (pages.txTrackingReport.patientsList.categories.<key>) and as the aggregation response key,
 * while `searchValue` is the raw lastTrackStatus value stored in the patient search model.
 */
export const TrackStatusCategories = [
  { key: 'onTrack', searchValue: TreatmentTrackOptions.OnTrack },
  { key: 'notOnTrack', searchValue: TreatmentTrackOptions.OffTrack }
]

/**
 * Figma frame 220 colors. The two track statuses reuse the timeline's on-track and off-track icon colors.
 */
export const TrackStatusColors = {
  onTrack: '#26C36F',
  notOnTrack: '#EB5757'
}

/**
 * Figma frame 220 colors the four reasons it shows. Its chart and its chips swap the Missing Attachment
 * and Broken Wire colors; the chart's bars and legend agree with each other, so they win. The other
 * reasons have no design color yet and take the fallback palette, in the order of TrackingConditionsTypes.
 */
const DESIGNED_REASON_COLORS = {
  [TrackingConditionsTypes.AlignersFit]: '#7E8DF3',
  [TrackingConditionsTypes.AlignerUnseating]: '#FFABAB',
  [TrackingConditionsTypes.MissingAttachments]: '#FFBD39',
  [TrackingConditionsTypes.BrokenWire]: '#A0CB7F'
}

const FALLBACK_REASON_PALETTE = ['#FFDD99', '#9ED8F5', '#D7A6F5', '#F59EC8', '#8FD8C3', '#C9B8A6', '#B8C4D9', '#F5B98F']

const UNDESIGNED_REASONS = Object.values(TrackingConditionsTypes).filter(reason => !DESIGNED_REASON_COLORS[reason])

export const getTrackingReasonColor = reason =>
  DESIGNED_REASON_COLORS[reason] ||
  FALLBACK_REASON_PALETTE[Math.max(UNDESIGNED_REASONS.indexOf(reason), 0) % FALLBACK_REASON_PALETTE.length]
